import { useEffect, useRef } from 'react'
import { useBogo } from '@mc/bogo-utils'
import { useBucket } from '@mc/experiments-react'
import { useFreeTrial } from '@mc/free-trial'
import { usePromotion } from '@mc/promo-utils'
import { trackExperimentViewed } from '@mc/track-event'
import {
  QUIZ_ENTRY_IN_STICKY_FOOTER_EXP_FLAG,
  type pen5646V1Variants,
} from '../constants'

/**
 * Base hook that determines if the quiz entry experiment should be shown and provides convenience vars to the other
 * hooks.
 */
export const useQuizEntryExperiment = () => {
  const { isPromotionOn } = usePromotion()
  const { isBogoOfferEligible } = useBogo()
  const { trial } = useFreeTrial()

  const bucket = useBucket<pen5646V1Variants>(
    QUIZ_ENTRY_IN_STICKY_FOOTER_EXP_FLAG,
  )

  // Show experiment when there are no active promotions, user is not on free trial, and is bucketed:
  const showExperiment =
    !isPromotionOn && !isBogoOfferEligible && !trial.eligible && !!bucket

  const isQuizEntryVariant =
    showExperiment && (bucket === 'variant_1' || bucket === 'variant_2')

  return { showExperiment, isQuizEntryVariant }
}

/**
 * Hook for the QuizEntryModal that handles Experiment Viewed tracking.
 */
export const useQuizEntryExpInModal = () => {
  const { showExperiment, isQuizEntryVariant } = useQuizEntryExperiment()
  const alreadyTracked = useRef(false)

  useEffect(() => {
    if (showExperiment && !alreadyTracked.current) {
      trackExperimentViewed(QUIZ_ENTRY_IN_STICKY_FOOTER_EXP_FLAG)
      alreadyTracked.current = true
    }
  }, [showExperiment])

  return { isQuizEntryVariant }
}
